module.exports = __webpack_public_path__ + "static/media/it-ticketing-system-thumbnail.432511f8.png";